export default __webpack_public_path__ + "static/media/map.33a22aa7.svg";